import React, { Component } from 'react';

import Chip from 'material-ui/Chip';
import Toggle from 'material-ui/Toggle';

import clientsStore from '../stores/clientsStore';
import ClientDialog from './ClientDialog';

import moment from 'moment';

import BridgeAppBar from './MainComponents/BridgeAppBar';
import SendTask from './MainComponents/SendTask';

import c3 from 'c3';



const borderRight = {
    borderRightColor: "#efefef",
    borderRightStyle: "solid",
    borderRightWidth: "1px"
};

const borderBottom = {
    marginBottom: "12px"
}

function secondsToString(seconds) {
    
    let numdays     = Math.floor(seconds / 86400);
    let numhours    = Math.floor((seconds % 86400) / 3600);
    let numminutes  = Math.floor(((seconds % 86400) % 3600) / 60);
    let numseconds  = ((seconds % 86400) % 3600) % 60;

    let strDays     = numdays > 0 ? numdays + " days " : "";
    let strHours    = numhours < 10 ? "0" + numhours : numhours;
    let strMinutes  = numminutes < 10 ? "0" + numminutes : numminutes;
    let strSeconds  = numseconds < 10 ? "0" + numseconds : numseconds;
    
    return  strDays + strHours + "h : " + strMinutes + "m : " + strSeconds + "s";
}

const Chips = ({items}) => (
    <div style={{display: 'flex', flexWrap: 'wrap', textAlign: "center", justifyContent: "center", marginTop: "8px"}}>
        {
            items.map((item, index) => (
                <Chip key={index} style={{marginLeft: "8px", marginBottom: "8px"}} backgroundColor="#42A5F5" labelColor="white">
                    {item}
                </Chip>
            ))
        }
    </div>
)

const ButtonChips = ({botones}) => (
    <div style={{display: 'flex', flexWrap: 'wrap', textAlign: "center", justifyContent: "center" ,marginTop: "8px"}}>
        {
            botones.map((boton, index) => (
                <Chip key={index} onTouchTap={boton._onClick} style={{marginLeft: "8px", marginBottom: "8px", width: "80px", justifyContent: "center"}}>
                    {boton.label}
                </Chip>
            ))
        }
    </div>
)

const Miniprops = ({name, value}) => (
    <div style={{textAlign: "center"}}>
        <p><span style={{fontWeight: 500}}>{name}</span><br />
        {value}</p>
    </div>
)

const DisplayDate = ({date}) => (
    <span>
        {
            date ? 
            moment(date, "YYYY-MM-DD hh:mm:ss").add(2, 'h').format("YYYY-MM-DD hh:mm:ss") : ""
        }
        <br />
        {
            date ?
            moment(date, "YYYY-MM-DD hh:mm:ss").add(2, 'h').fromNow() : ""
        }
    </span>
);

const ClientControl = ({info, control}) => (
    <div>
        <br />
        <br />
        <br />

        <div className="container">
            <div className="row">
                <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                    <div className="row" style={borderBottom}>
                        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                            <Miniprops name="WORKING DIRECTORY" value={control.curdir} />
                        </div>
                    </div>
                    <div className="row" style={borderBottom}>
                        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6" style={borderRight}>
                            <Miniprops name="UPTIME" value={secondsToString(Math.floor(info.uptime))} />
                        </div>
                        
                        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                            <Miniprops name="HOME" value={control.homedir} />
                        </div>
                    </div>
                    <div className="row" style={borderBottom}>
                        <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4" style={borderRight}>
                            <Miniprops name="HOSTNAME" value={control.hostname} />
                        </div>
                        <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4" style={borderRight}>
                            <Miniprops name="OS" value={control.osname} />
                        </div>
                        <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
                            <Miniprops name="ARCHITECTURE" value={control.arch} />
                        </div>
                    </div>
                    <div className="row" style={borderBottom}>
                        <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4" style={borderRight}>
                            <Miniprops name="OS TYPE" value={control.ostype} />
                        </div>
                        <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4" style={borderRight}>
                            <Miniprops name="PLATFORM" value={control.platform} />
                        </div>
                        <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4" >
                            <Miniprops name="RELEASE" value={control.osrelease} />
                        </div>
                    </div>
                        <Miniprops name="CPUS" />
                        <ul>
                        {
                            info.cpus ? info.cpus.map((item, index)=> (
                                <li key={index}>
                                    <p>
                                        <b>Model:</b> {item.model}<br />
                                        <b>Speed:</b> {item.speed} 
                                    </p>
                                </li>
                            )) : <span />
                        }
                        </ul>                        

                </div>
                
                <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                    <div>
                        <div style={{textAlign: "center", fontWeight: 300}}>Memoria RAM</div>
                        <div id="memChart">
                        </div> 
                    </div>
                </div>
            </div>
        </div>


    </div>
);

/* const ClientInfo = ({info, control, onEdit}) => (
    <div style={{margin: "16px", paddingTop:"32px"}}>
        <div style={{fontSize: "24px", fontWeight: "300", textAlign: "center"}}>{info.clientName}</div>
        <div style={{fontSize: "14px", fontWeight: "300", color: "#616161", marginTop: "8px", textAlign: "center"}}>
            {info.description}
            <br />
            <div style={{display: 'block'}}>
                <ButtonChips 
                    botones={[
                        {
                            label: "Editar",
                            _onClick: () => {
                                onEdit(info);
                            }
                            
                        },
                        {
                            label: "LABEL2"
                        }
                    ]}
                    style={{display: 'block'}}
                />
                {
                    console.log("INFO: " + JSON.stringify(info.enabled))
                }
                <div style={{display: 'flex', flexWrap: 'wrap', textAlign: "center", justifyContent: "center"}}>
                    <Chip>
                        <Toggle 
                            label="Habilitado"
                            labelPosition="left"
                            //defaultToggled={true}
                            defaultToggled={info.enabled === "1"}
                            onToggle={(event, checked) => {
                                //console.log("DISABLED DEF" + event.target.disabled);
                                //console.log(checked);
                                event.target.disabled = "disabled";
                                clientsStore.updateClientStatus(checked);
                                event.target.disabled = "";
                            }}
                            style={{marginTop: "4px", marginBottom: "4px"}}
                        />
                        
                    </Chip>
                </div>
            </div>
            {
                control ?
                <p style={{fontWeight: 500}}>Conectado por ultima vez: <DisplayDate date={info.lastConnection} /></p> :
                <p style={{fontWeight: 500}}>Este cliente no se ha conectado todavia</p>
            }
        </div>
        <Chips items={info.labels ? info.labels.split(",") : []} />
        {
            control ? 
            <ClientControl info={info} control={control} /> : 
            null
        }
    </div>
); */

class ClientInfo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            info: {},
            toggle: true
        };
    }
    componentWillReceiveProps(nextProps) {
        this.setState({info: nextProps.info});
        this.setState({toggle: nextProps.info.enabled === "1"})
    }

    _refreshClientStatus(state) {
        this.setState({toggle : state})
    }

    render() {
        return (
            <div style={{margin: "16px", paddingTop:"32px"}}>
                <div style={{fontSize: "24px", fontWeight: "300", textAlign: "center"}}>{this.state.info.clientName}</div>
                <div style={{fontSize: "14px", fontWeight: "300", color: "#616161", marginTop: "8px", textAlign: "center"}}>
                    {this.state.info.description}
                    <br />
                    <div style={{display: 'block'}}>
                        <ButtonChips 
                            botones={[
                                {
                                    label: "Editar",
                                    _onClick: () => {
                                        this.props.onEdit(this.state.info);
                                    }
                                }
                            ]}
                            style={{display: 'block'}}
                        />
                        <div style={{display: 'flex', flexWrap: 'wrap', textAlign: "center", justifyContent: "center"}}>
                            <Chip>
                                <Toggle 
                                    label="Habilitado"
                                    labelPosition="left"
                                    toggled={this.state.toggle}
                                    onToggle={(event, checked) => {
                                        event.target.disabled = "disabled";
                                        clientsStore.updateClientStatus({
                                            client: {
                                                clientID: this.state.info.clientID,
                                                enabled: this.state.toggle
                                            },
                                            onSuccess: (state) =>{
                                                this._refreshClientStatus(state);
                                            }
                                        });
                                        event.target.disabled = "";
                                    }}
                                    style={{marginTop: "4px", marginBottom: "4px"}}
                                />
                                
                            </Chip>
                        </div>
                    </div>
                    {
                        this.props.control ?
                        <p style={{fontWeight: 500}}>Conectado por ultima vez: <DisplayDate date={this.state.info.lastConnection} /></p> :
                        <p style={{fontWeight: 500}}>Este cliente no se ha conectado todavia</p>
                    }
                </div>
                <Chips items={this.state.info.labels ? this.state.info.labels.split(",") : []} />
                {
                    this.props.control ? 
                    <ClientControl info={this.state.info} control={this.props.control} /> : 
                    null
                }
            </div>
        );
    }
}



class ClientDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            clientInfo: {},
            control: {}
        }
    }
    componentDidMount() {
        let q = c3.generate({
            bindto: '#memChart',
            data: {
                columns: [  
                    ['Usada', 0],
                    ['Libre', 0]    
                ],
                type: 'pie',
                colors: {
                    Libre: "#BDBDBD",
                    Usada: "#2196F3"
                }
            },
            pie: {
                label: {
                    format: function (value, ratio, id) {
                        return value + ' GB'; // d3.format('GB')(value);
                    }
                }
            }
        });
        
        clientsStore.getClients({
            id: this.props.match.params.id,
            onSuccess: (response) => {
                this.setState({clientInfo: response, control: response.controlValues}, () => {
                    if(this.state.control) {
                        q.load({
                            columns: [
                                ['Usada', Math.floor(((this.state.clientInfo.freemem)/1000)/1000)/1000],
                                ['Libre', Math.floor(((this.state.control.totalmem-this.state.clientInfo.freemem)/1000)/1000)/1000]    
                            ]
                        });
                    }
                });
            }
        });
    }

    _onEdit(data) {
        // console.log("Edit client", data);
        this.refDialog.__openAndSetFields({
            clientID        : data.clientID,
            clientName      : data.clientName,
            description     : data.description,
            labels          : data.labels,
            isUpdate        : true
        });
    }
    _refreshClient(newClientInfo) {
        this.setState({clientInfo: newClientInfo});
    }

    _updateClient(data, onSuccess, onError) {
        clientsStore.editClient({
            client: {
                clientID: data.clientID,
                clientName: data.clientName,
                description: data.description,
                labels: data.labels
            },
            onSuccess: (clientInfo) => {
                this._refreshClient(clientInfo);
                if(onSuccess) onSuccess();
            },
            onError: () => {
                if(onError) onError();
            }
        });
    }
    
    render() {
        return(
            <div>
                <BridgeAppBar toStoredCommands={"/storedcommands/" + this.props.match.params.id} toCommands={"/commands/" + this.props.match.params.id} toLogs={"/logs/" + this.props.match.params.id} />
                <ClientInfo 
                    info={this.state.clientInfo} 
                    control={this.state.control}
                    onEdit={(client) => { 
                        this._onEdit({
                            clientID        : client.clientID,
                            clientName      : client.clientName,
                            description     : client.description,
                            labels          : client.labels
                        });
                    }} 
                />
                <ClientDialog 
                    editClient={(data, onSuccess, onError) => {
                        this._updateClient(data, onSuccess, onError);
                    }}
                    ref={(refDialog) => this.refDialog = refDialog}
                />
                <SendTask trueTarget={[this.state.clientInfo]} />
            </div>
        );
    }
}
export default ClientDetails;




// WEBPACK FOOTER //
// ./src/components/ClientDetails.js